module.exports = __webpack_public_path__ + "static/media/waiting.c21afa41.png";